import React, { useState } from "react";
import ContactPropertyImage from "../../assets/images/homepage_03.png";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../designSystem/buttons/PrimaryButton";

const ContactUsComponent = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    number: "",
    email: "",
    message: "",
    consent: false,
  });
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = ({ target }) => {
    const { name, value, type, checked } = target;

    setForm((previousForm) => ({
      ...previousForm,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((previousErrors) => ({ ...previousErrors, [name]: "" }));
    setSubmitStatus("");
  };

  const validate = () => {
    const nextErrors = {};

    if (!form.name.trim()) nextErrors.name = "Name is required";
    if (!form.number.trim()) nextErrors.number = "Number is required";
    if (!form.email.trim()) nextErrors.email = "Email is required";
    if (!form.message.trim()) nextErrors.message = "Message is required";
    if (!form.consent) {
      nextErrors.consent = "Please confirm you have read the privacy policy";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    setSubmitStatus("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/send-adviser-contact-confirmation`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: form.name.trim(),
            number: form.number.trim(),
            email: form.email.trim(),
            message: form.message.trim(),
            to: (process.env.REACT_APP_ADVISER_EMAIL || "").trim(),
          }),
        },
      );

      if (!response.ok) throw new Error("Contact form request failed");

      setForm({
        name: "",
        number: "",
        email: "",
        message: "",
        consent: false,
      });
      setErrors({});
      setSubmitStatus("Thanks, your message has been sent successfully.");
    } catch (error) {
      setSubmitStatus(
        "Sorry, your message could not be sent. Please try again later.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      id="contact-us"
      // className="background-container bg-white contact-section"
    >
      <section className="background-container bg-gray-3">
        <div className="content-container row-center grid2 gap-xxxxxl row-center ">
          <div className="column gap-l">
            <h3 className="text-primary-2">Ready to discuss your mortgage?</h3>
            <div className="column gap-m">
              <div className="content text-primary-2">
                Whether you're taking your first step onto the property ladder,
                growing your portfolio or looking for a more complex lending
                solution, CAPC is here to help. Get in touch today to discuss
                your requirements and discover how we can support your mortgage
                journey.
              </div>
              <div className="body1 text-primary-2">
                *Your home may be repossessed if you do not keep up with
                repayments on your mortgage.
              </div>
            </div>
          </div>
          <img
            src={ContactPropertyImage}
            alt="Traditional residential property representing CAPC mortgage advice"
            className="hero-image"
          />
        </div>
      </section>
      <div className="background-container bg-primary-1">
        <div className="content-container">
          <div className="column gap-xl align-center">
            <h3 className="text-white">Google Reviews</h3>
            <PrimaryButton
              text="view or leave a review"
              onClick={() =>
                window.open(
                  "https://www.google.com/maps/place//data=!4m3!3m2!1s0x4870cfb8200d44c5:0x8d91e064307f2758!12e1?source=g.page.m._&laa=merchant-review-solicitation",
                  "_blank",
                )
              }
            />
          </div>
        </div>
      </div>
      <div className="content-container contact-section-inner gap-xxxxxl  background-container bg-white">
        {/* <div className="column gap-s">
        <div className="content-semibold primary uppercase align-left">
          contact
        </div>
        </div> */}{" "}
        <div className="contact-details-column" aria-label="Contact details">
          <div className="contact-location-copy align-left">
            <h4 className="primary">Contact Details</h4>
            <div className="contact-details">
              <div className="contact-detail">
                <span className="body2-semibold text-primary-1 uppercase">
                  Email
                </span>
                <a
                  className="body1 text-gray-1 contact-link"
                  href="mailto:enquiries@capc.uk.com"
                >
                  enquiries@capc.uk.com
                </a>
              </div>
              <div className="contact-detail">
                <span className="body2-semibold text-primary-1 uppercase">
                  Telephone
                </span>
                <a
                  className="body1 text-gray-1 contact-link"
                  href="tel:+441789201914"
                >
                  01789 201914
                </a>
              </div>
              <div className="contact-detail">
                <span className="body2-semibold text-primary-1 uppercase">
                  Address
                </span>
                <a
                  className="body1 text-gray-1 contact-link"
                  href="https://www.google.com/maps/search/?api=1&query=7%20Arrow%20Court%2C%20Alcester%2C%20B49%206PU"
                  target="_blank"
                  rel="noreferrer"
                >
                  CAPC - Mortgage Brokers, 7 Arrow Court, Alcester, B49 6PU
                </a>
              </div>
            </div>
          </div>
          <iframe
            className="contact-map"
            title="Map showing CAPC - Mortgage Brokers, 7 Arrow Court, Alcester, B49 6PU"
            src="https://www.google.com/maps?q=7%20Arrow%20Court%2C%20Alcester%2C%20B49%206PU&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
        <div
          className="column gap-l contact-form-column column-stretch "
          aria-label="Contact form"
        >
          <h4 className="primary">Get in Touch</h4>
          <form className="column gap-m" onSubmit={handleSubmit} noValidate>
            <div className="column gap-s">
              <label
                className="body2-semibold text-primary-1"
                htmlFor="contact-name"
              >
                Name*
              </label>
              <input
                id="contact-name"
                className="width-100"
                name="name"
                value={form.name}
                onChange={handleChange}
                autoComplete="name"
              />
              {errors.name && (
                <span className="body2 text-error">{errors.name}</span>
              )}
            </div>{" "}
            <div className="column gap-s">
              <label
                className="body2-semibold text-primary-1"
                htmlFor="contact-email"
              >
                Email*
              </label>
              <input
                id="contact-email"
                className="width-100"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                autoComplete="email"
              />
              {errors.email && (
                <span className="body2 text-error">{errors.email}</span>
              )}
            </div>
            <div className="column gap-s">
              <label
                className="body2-semibold text-primary-1"
                htmlFor="contact-number"
              >
                Number*
              </label>
              <input
                id="contact-number"
                className="width-100"
                name="number"
                type="tel"
                value={form.number}
                onChange={handleChange}
                autoComplete="tel"
              />
              {errors.number && (
                <span className="body2 text-error">{errors.number}</span>
              )}
            </div>
            <div className="column gap-s">
              <label
                className="body2-semibold text-primary-1"
                htmlFor="contact-message"
              >
                Message*
              </label>
              <textarea
                id="contact-message"
                className="width-100"
                name="message"
                value={form.message}
                onChange={handleChange}
                rows={8}
              />
              {errors.message && (
                <span className="body2 text-error">{errors.message}</span>
              )}
            </div>
            <div className="row-flex gap-s width-100">
              <input
                id="contact-consent"
                name="consent"
                type="checkbox"
                checked={form.consent}
                onChange={handleChange}
              />
              <label className="body2 text-primary-1" htmlFor="contact-consent">
                *I confirm I have read the{" "}
                <span
                  type="button"
                  className="text-button"
                  onClick={() => navigate("/privacy-policy")}
                  style={{ textDecoration: "underline" }}
                >
                  Privacy Policy
                </span>
                .
              </label>
            </div>
            {errors.consent && (
              <span className="body2 text-error">{errors.consent}</span>
            )}
            <PrimaryButton
              type="submit"
              text={isSubmitting ? "SENDING..." : "SUBMIT"}
              disabled={isSubmitting}
            />
            {submitStatus && (
              <div
                className={`body2 ${
                  submitStatus.startsWith("Thanks")
                    ? "text-success"
                    : "text-error"
                }`}
                role="status"
              >
                {submitStatus}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUsComponent;
